import {NgModule} from "@angular/core";
import {DiskSizePipe} from "@app/shared/pipes/disk-size/disk-size.pipe";

@NgModule({
  declarations: [
    DiskSizePipe,
  ],
  imports: [],
  exports: [
    DiskSizePipe,
  ],
  providers: []
})
export class DiskSizePipeModule { }
